export default __webpack_public_path__ + "static/media/Valor Logo.a1b2192b.png";